import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"


import BackgroundImage from 'gatsby-background-image'

import Services from "../components/services"
import Circle from "../components/circle"
import Masthead from "../components/masthead"




class IndexPage extends React.Component {


  componentDidMount() {
    //Parallax Scrolling
    //How to? Add parallax to any element, and optionally data-speed
    //Objects are scrolled up/down based on a percentage of the the
    //current scrolled value out of total scrolled view
    //Higher speed = faster scroll speed. Speed defaults to 1.
    window.addEventListener('scroll',handleScroll);


    const els = Array.from(document.querySelectorAll('.parallax'))
    //All Parallax els are pre-defined with data-otop to capture original top position.
    //This ensure elements return to their starting place
    els.map(el=>{
      const oTop = parseInt(window.getComputedStyle(el).getPropertyValue('top'))
      el.setAttribute('data-otop',oTop);
    })

    function handleScroll(e){

      els.map(el=>{
        const top = window.scrollY / window.innerHeight
        const oTop = el.getAttribute('data-otop')
        let speed = el.getAttribute('data-speed') || 1
        const t = (100*speed * (top)).toFixed(8);

        // console.log("Scroll Top")
        // console.log(el.offsetTop)
        // console.log(window.scrollY+window.innerHeight)
        el.style.setProperty('top',`${oTop -t}px`);




      })

    }
  }




  render() {
    const { data } = this.props

    return(
      <Layout>
        <SEO title="ZoomHR — Your one stop for all things HR."/>
        <Masthead>
          <div className={`page-wrap image-content`}>
            <span><h1 className={'parallax'} data-speed="1">Your one stop for all things <span className={`blue-text`}>HR</span>.</h1></span>
          </div>
          <Circle id="c1" speed={2} modifiers={`quarter--white`}/>
          <Circle id="c2" speed={3} modifiers={`quarter--blue hidden-m`} rotation={`-90deg`} />
          <Circle id="c3" speed={7} modifiers={``}/>
        </Masthead>



        <div className={`main-content`}>
          <div className={`page-wrap`}>
            <div className={`callout-box parallax`} data-speed="2.5">
              <div className={`callout-box-wrap`}>
                <p>With a team of consultants who have both public and private, large and small company experience supporting
                  businesses as Human Resource partners – we understand the inner workings of organizations and what it takes to
                  have a successful HR department. Whether you require onsite or offsite, short or long term support – our team
                  can help with your needs.</p>
              </div>


            </div>
            <div className={`services-area`}>
              <h2>Our Services</h2>
              <Services/>
            </div>
          </div>
          <div className={'circle-section'}>
            <div className={`circle-section-wrap`}>
              {/*<Circle speed={3} modifiers={``} dir={`left`} dirVal={`-25%`} top={`150%`}/>*/}
              <Circle id="c4" speed={4} version={`black`} modifiers={`quarter--black`} opacity={0.2}/>
              {/**/}
              <Circle id="c5" speed={2} version={`black`} opacity={1}/>
              <Circle id="c6" speed={1} modifiers={`quarter--blue`} rotation={`180deg`}/>
            </div>

          </div>
        </div>

        <div className={`image-text-wrap`}>
          <BackgroundImage className={`image-text`} fluid={data.hr.childImageSharp.fluid}>
            <div className={`image-content page-wrap `}>
            <span>
              <p>Unlike many firms with consultants that have limited hands on HR business experience, we have worked as members
              of HR teams and supported leaders across multinational organizations.</p>
            </span>
            </div>
            <div className={'image-overlay'}/>

          </BackgroundImage>



        </div>

      </Layout>
    )
  }
}


export const indexQuery = graphql`
  query{
     
     hr: file(relativePath: { eq: "HR.jpg" }) {
        childImageSharp {
          fluid(quality:80) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    
  }
`

export default IndexPage
